import React from "react";
import { SvgIcon } from "@mui/material";

export const SensorOpenIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 19C12 20.1 11.1 21 10 21H4C2.9 21 2 20.1 2 19V5C2 3.9 2.9 3 4 3H10C11.1 3 12 3.9 12 5V19ZM22 17C22 17.55 21.55 18 21 18H19C18.45 18 18 17.55 18 17V7C18 6.45 18.45 6 19 6H21C21.55 6 22 6.45 22 7V17Z"
      opacity="0"
    />
    <path d="M12 19C12 20.1 11.1 21 10 21H4C2.9 21 2 20.1 2 19V5C2 3.9 2.9 3 4 3H10C11.1 3 12 3.9 12 5V19Z" />
    <g transform="translate(4, 1) rotate(25 16 12)">
      <path d="M18 17C18 17.55 17.55 18 17 18H15C14.45 18 14 17.55 14 17V7C14 6.45 14.45 6 15 6H17C17.55 6 18 6.45 18 7V17Z" />
    </g>
  </SvgIcon>
);

export const SensorClosedIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 19C12 20.1 11.1 21 10 21H4C2.9 21 2 20.1 2 19V5C2 3.9 2.9 3 4 3H10C11.1 3 12 3.9 12 5V19ZM18 17C18 17.55 17.55 18 17 18H15C14.45 18 14 17.55 14 17V7C14 6.45 14.45 6 15 6H17C17.55 6 18 6.45 18 7V17Z" />
  </SvgIcon>
);
